import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { UserApi } from 'mvppoker-portal-common/api'
import React  from 'react'
import toast from 'react-hot-toast'
import { useSelector } from 'react-redux'
import { RootState } from '../../../state/AppStore'
import { createMVPModal } from '../Modal'
import { ReferralModalView } from './ReferralModalView'

class ReferralModal
{
	Show() 
	{
		NiceModal.show(createMVPModal('referral-modal', () =>
		{
			const modal = useModal()
			const user = useSelector((root: RootState) => root.activeUser.user)!
		
			const handleClick = (onClick: () => void) => {
				modal.hide()
				onClick()
			}

			const clickCode = () => {
				navigator.clipboard.writeText(user.info.referralCode)
				toast.success('Referral Code copied to clipboard!')
			}
		
			const clickLink = () => {
				const link = `https://app.mvppoker.com/invite?referralCode=${user.info.referralCode}`
				navigator.clipboard.writeText(link)
				toast.success('Referral Link copied to clipboard!')
			}

			return <ReferralModalView 
				user={user}
				
				clickCode={() => handleClick(clickCode)}
				clickLink={() => handleClick(clickLink)}
			/>
		}))
	}
}

const modal = new ReferralModal()
export default modal